export default "__VITE_ASSET__xbWptGOl__";